/* No form replacements, customer tracking, third-party scripts or auto-playing sliders. */
(() => {
  'use strict';
  if (window.bvjHomeRefinementInstalled) return;
  window.bvjHomeRefinementInstalled = true;
  const desktop = window.matchMedia('(min-width:990px)');
  function arrange() {
    const home = document.querySelector('[data-bvj-home]');
    if (!home) return;
    const layout = home.querySelector('.bh-layout');
    const hero = home.querySelector('.bh-hero');
    const categories = home.querySelector('.bh-categories');
    const features = home.querySelector('.bh-features');
    const trust = home.querySelector('.bh-trust');
    if (!layout || !hero || !categories || !features || !trust) return;
    // Match visual order to reading and keyboard order at each breakpoint.
    if (desktop.matches) {
      if (hero.nextElementSibling !== features) hero.after(features);
      if (features.nextElementSibling !== trust) features.after(trust);
    } else {
      if (hero.nextElementSibling !== categories) hero.after(categories);
      if (categories.nextElementSibling !== features) categories.after(features);
      if (features.nextElementSibling !== trust) features.after(trust);
    }
  }
  function initialise() {
    if (!document.querySelector('main[data-template="list-collections"] [data-bvj-home]')) return;
    arrange();
    document.querySelectorAll('.header__search input[type="search"]').forEach(input => {
      input.placeholder = 'Zoek product, merk of artikelnummer';
    });
    const buttons = document.querySelector('.advice-newsletter__buttons');
    if (buttons) {
      const contact = Array.from(buttons.querySelectorAll('a')).find(link => {
        try { return new URL(link.href).pathname.endsWith('/pages/contact'); }
        catch (_) { return false; }
      });
      if (contact && buttons.firstElementChild !== contact) buttons.prepend(contact);
    }
    const header = document.querySelector('.section-header');
    if (header && !header.dataset.bhMeasured && 'ResizeObserver' in window) {
      header.dataset.bhMeasured = 'true';
      const observer = new ResizeObserver(entries => {
        const height = Math.round(entries[0].target.getBoundingClientRect().height);
        document.documentElement.style.setProperty('--header-height', height + 'px');
      });
      observer.observe(header);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once:true});
  else initialise();
  desktop.addEventListener('change', arrange);
  document.addEventListener('shopify:section:load', initialise);
})();
